import { useQueryClient } from 'react-query';

import { usePost } from '../../utils/reactQuery';
import { ApiRoutesEnum } from '../../utils/routes';

export const useUpdateEmailFilter = () => {
  const queryClient = useQueryClient();
  return usePost({
    url: ApiRoutesEnum.emailsUpdateFilter,
    onSuccess: () => {
      queryClient.invalidateQueries([ApiRoutesEnum.emailsFilters]);
    },
  });
};
